import { Injectable } from '@angular/core'
import { ViewMultiValueDialogComponent } from '../view-multi-value-dialog/view-multi-value-dialog.component'
import { MbModalService } from '../../../../shared/services/modal.service'
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap'

@Injectable({
  providedIn: 'root'
})
export class ViewMultiValueDialogService {
  modalRef: NgbModalRef | null = null
  components: string[] = []

  constructor (protected modalService: MbModalService) { }

  open (multiValueData: any, modalTitle: string): void {
    const modalRef = this.modalService.open
              (ViewMultiValueDialogComponent,
                { centered: true, scrollable: true, modalDialogClass: 'mb-ng-modal' } as any)
    modalRef.componentInstance.modalData = multiValueData
    modalRef.componentInstance.modalTitle = modalTitle
  }
}
